import { forwardRef, InputHTMLAttributes, ReactNode } from 'react';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  id: string;
  label: ReactNode;
};

export const RadioButton = forwardRef<HTMLInputElement, Props>(({ id, label, ...rest }, ref) => {
  return (
    <div className="flex items-center mr-4">
      <input
        {...rest}
        ref={ref}
        id={id}
        type="radio"
        className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-gray-800 focus:ring-2 dark:bg-gray-700 dark:border-gray-600"
      />
      <label htmlFor={id} className="ml-2 text-sm font-medium text-gray-900 dark:text-gray-300">
        {label}
      </label>
    </div>
  );
});

RadioButton.displayName = 'RadioButton';
